<template>
  <div class="partner bg-white text-default padding--top-4 padding--bottom-4">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h4 v-if="raceSeries === this.dtm" class="text-uppercase margin--bottom-2">{{ $t('partner.title') }}</h4>
          <h4 v-if="raceSeries === this.dtmTrophy" class="text-uppercase margin--bottom-2">{{ $t('partnerTrophy.title') }}</h4>
        </div>
      </div>
      <div class="row" :class="{ 'justify-content-between': premiumPartners.length > 2, 'justify-content-left': premiumPartners.length <= 2 }">
        <div v-for="(partner, index) in premiumPartners" :key="index" class="col-auto">
          <a v-if="partner.link && partner.link.external" :href="partner.link.url" target="_blank" :title="partner.link.title">
            <img
              class="partner__image"
              :alt="partner.link.title"
              :width="partner.logo.width"
              :height="partner.logo.height"
              :src="partner.logo.url"/>
          </a>
        </div>
      </div>
      <div v-if="secondLevelPartners.length > 0" class="col-12 partner__hr"></div>
      <div class="row">
        <div v-for="(partner, index) in secondLevelPartners" :key="index" class="col-auto partner__second-level">
          <a :href="partner.link && partner.link.url ? partner.link.url : '#'" target="_blank" :title="partner.link ? partner.link.title : ''">
            <img
              class="partner__image"
              :alt="partner.link ? partner.link.title : ''"
              :width="partner.logo.width"
              :height="partner.logo.height"
              :src="partner.logo.url"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'Partner',
  data () {
    return {
      partners: [],
      dtm: AppConst.DTM,
      dtmTrophy: AppConst.DTM_TROPHY
    };
  },
  computed: {
    premiumPartners: function () {
      return this.partners.filter(partner => {
        return partner.premiumPartner;
      });
    },
    secondLevelPartners: function () {
      return this.partners.filter(partner => {
        return !partner.premiumPartner;
      });
    },
    queryName: function () {
      return this.$store.getters['page/raceSeriesPartner'];
    },
    raceSeries: function () {
      return this.$store.getters['page/raceSeries'];
    }
  },
  methods: {
    async fetchPartners () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryName}`,
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.partners = response.partners ? response.partners : response.partnerTrophies ? response.partnerTrophies : [];
        });
    }
  },
  watch: {
    $route () {
      this.fetchPartners();
    }
  },
  created () {
    this.fetchPartners();
  }
};
</script>

<style lang="scss" scoped>
  .partner {
    &__image {
      width: 115px;
      height: 75px;
      max-width: 100%;
    }

    &__hr {
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      border: 0;
      border-top: 1px solid $color-bg;
      opacity: 0.8;
    }

    &__second-level {
      transform: scale(0.75);
    }
  }
</style>
